import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private startTime = performance.now();

  milestones: { [key: string]: number } = {};

  private logMilestone(name: string) {
    if (!this.milestones[name]) {
      this.milestones[name] = performance.now() - this.startTime;
    }
  }

  private moduleProgress = 0;
  private dataProgress = 0;
  private assetProgress = 0;

  private progressSubject = new BehaviorSubject<number>(0);
  progress$ = this.progressSubject.asObservable();

  private updateProgress() {
    try {
      const total = (this.moduleProgress + this.dataProgress + this.assetProgress) / 3;
      this.progressSubject.next(total);

      if (this.moduleProgress === 1) this.logMilestone('Modules loaded');
      if (this.dataProgress === 1) this.logMilestone('Data loaded');
      if (this.assetProgress === 1) this.logMilestone('Assets loaded');
    } catch (error) {
      console.error('Error updating progress:', error);
      // Ensure progress is always a valid number
      this.progressSubject.next(0);
    }
  }

  setModuleProgress(current: number, total: number) {
    try {
      this.moduleProgress = total > 0 ? current / total : 0;
      console.log("moduleProgress"+  this.moduleProgress)
      this.updateProgress();
    } catch (error) {
      console.error('Error setting module progress:', error);
    }
  }

  setDataProgress(current: number, total: number) {
    try {
      this.dataProgress = total > 0 ? current / total : 0;
      console.log("dataProgress"+  this.dataProgress)
      this.updateProgress();
    } catch (error) {
      console.error('Error setting data progress:', error);
    }
  }

  setAssetProgress(current: number, total: number) {
    try {
      this.assetProgress = total > 0 ? current / total : 0;
      console.log("assetProgress"+  this.assetProgress)
      this.updateProgress();
    } catch (error) {
      console.error('Error setting asset progress:', error);
    }
  }

  getMilestoneLog(): string[] {
    return Object.entries(this.milestones).map(
      ([name, ms]) => `${name}: ${(ms / 1000).toFixed(2)}s`
    );
  }
}
